import { FC } from "react";
import DeleteDialog from "@/components/dialogs/delete-dialog";
import {
  showErrorToast,
  showSuccessToast,
} from "@/components/custom-toasts/toasts";
import useWorkspace from "@/hooks/useWorkspace";
import Workspace, {
  getAllWorkspaceDocuments,
} from "@/models/workspace/Workspace";
import { logger } from "@/lib/logger";

interface DeleteOrphanedWorkspaceDialogProps {
  isOpen: boolean;
  onClose: () => void;
  workspace: Workspace | null;
}

const DeleteOrphanedWorkspaceDialog: FC<DeleteOrphanedWorkspaceDialogProps> = ({
  isOpen,
  onClose,
  workspace,
}) => {
  const { remove } = useWorkspace();
  const documentCount = workspace
    ? getAllWorkspaceDocuments(workspace).length
    : 0;

  const handleDelete = async () => {
    if (!workspace) return;

    try {
      await remove.mutateAsync(workspace.id);
      showSuccessToast(`Workspace "${workspace.name}" er slettet`, "Slettet");
      onClose();
    } catch (error) {
      logger.error("Failed to delete orphaned workspace", {
        operation: "deleteOrphanedWorkspace",
        error,
        workspaceId: workspace.id,
      });
      showErrorToast("Fejl ved sletning af workspace. Prøv igen.", "Fejl");
    }
  };

  if (!workspace) return null;

  return (
    <DeleteDialog
      isOpen={isOpen}
      setIsOpen={(open) => {
        if (!open) onClose();
      }}
      isDisabled={remove.isPending}
      onDelete={handleDelete}
      entityName={workspace.name}
      isDeleteLoading={remove.isPending}
      customTrigger
      extraDescription={
        <p className="text-center text-sm text-muted-foreground">
          Workspace indeholder {documentCount}{" "}
          {documentCount === 1 ? "dokument" : "dokumenter"}.
        </p>
      }
    />
  );
};

export default DeleteOrphanedWorkspaceDialog;
